// export const config = {
// 	API_MWSVENDORONBOARDING_BASE_URL: 'https://mwsvendoronboarding.12mu1sfav9q7.us-east.codeengine.appdomain.cloud',
// 	API_MWSSTOREFRONT_BASE_URL: 'https://mwsstorefront.12mu1sfav9q7.us-east.codeengine.appdomain.cloud',
// 	API_MSWSSTOREMANAGER_BASE_URL: 'https://mswstoremanager.12mu1sfav9q7.us-east.codeengine.appdomain.cloud',
// 	API_MWSSTOREMANAGERAI_BASE_URL: 'https://mwsstoremanager-ai.12mu1sfav9q7.us-east.codeengine.appdomain.cloud'
// };

/*
  Legacy URLs:
    API_MWSVENDORONBOARDING_BASE_URL: 'https://mwsvendoronboarding.12mu1sfav9q7.us-east.codeengine.appdomain.cloud'
    API_MWSSTOREFRONT_BASE_URL: 'https://mwsstorefront.12mu1sfav9q7.us-east.codeengine.appdomain.cloud'
    API_MSWSSTOREMANAGER_BASE_URL: 'https://mswstoremanager.12mu1sfav9q7.us-east.codeengine.appdomain.cloud'
    API_MWSSTOREMANAGERAI_BASE_URL: 'https://mwsstoremanager-ai.12mu1sfav9q7.us-east.codeengine.appdomain.cloud'
  */

//PRODUCTION URLs
//
export const config = {
  API_MWSVENDORONBOARDING_BASE_URL: 'https://mwsvendoronboarding.microstores.net',
  API_MWSSTOREFRONT_BASE_URL: 'https://mwsstorefront.microstores.net',
  API_MSWSSTOREMANAGER_BASE_URL: 'https://mwsstoremanager.microstores.net',
  API_MWSSTOREMANAGERAI_BASE_URL: 'https://storemanager-ai.microstores.net'
};